import ApiRequest from "./ApiRequest";

interface IParamType {
}

class AxiosGetAttendanceStatus extends ApiRequest<IParamType> {
    constructor() {
        super("/v2/attendance/statuses");
    }

    get(token: string) {
        return this.get_request(token);
    }
}

export default AxiosGetAttendanceStatus;
